import { ListItem, Text, UnorderedList, VStack } from "@chakra-ui/react"
import Tip, { TipProps } from "../../tips/Tip"

export function HomeWelcomeAllTransitionalBlankSlateTip(
  props: Partial<TipProps>
) {
  return (
    <Tip
      tip={{
        id: "home-welcome-all-transitional-blank-slate",
        title: `Welcome to your new Home Screen`,
        content: (
          <VStack>
            <Text color="inherit" mt={0}>
              The new Home Screen below unifies all your Paths into a focused
              screen. You can now:
            </Text>
            <UnorderedList>
              <ListItem>Move any Path to the top of the list.</ListItem>
              <ListItem>
                Set aside Paths you no longer need to see (but without changing
                anything)
              </ListItem>
              <ListItem>Create or join Paths much more quickly.</ListItem>
            </UnorderedList>
          </VStack>
        )
      }}
      icon="lightbulb-on"
      layout="dismissable"
      colorScheme="dark"
      {...props}
    />
  )
}

export default HomeWelcomeAllTransitionalBlankSlateTip
